import SectionHeading from '../../components/SectionHeading';
import RichText from '../../components/RichText';
import Loader from '../../components/Loader';
import CategoryIcon from '../../components/CategoryIcon';
import useFetch from '../../hooks/useFetch';
import { getServices } from '../../services/api';

const FALLBACK_SERVICES = [
  {
    id: '1',
    icon: '📄',
    title: 'LOA & FBA Documentation',
    description:
      'We provide Letters of Authorization and fully compliant invoices that Amazon accepts — so your listings stay live and ungated.',
  },
  {
    id: '2',
    icon: '🚚',
    title: 'Direct Warehouse Distribution',
    description:
      'Ship directly from our U.S. warehouses to Amazon fulfillment centers — fast, reliable, and with full tracking visibility.',
  },
  {
    id: '3',
    icon: '💵',
    title: 'Competitive Wholesale Pricing',
    description:
      'Bulk pricing structured to maximize your ROI. We source products with strong margins and low Best Seller Rank for maximum velocity.',
  },
  {
    id: '4',
    icon: '📦',
    title: 'Custom & Bulk Orders',
    description:
      'Need a specific quantity or product mix? We accommodate custom orders tailored to your inventory needs and growth plans.',
  },
  {
    id: '5',
    icon: '👥',
    title: 'Dedicated Account Support',
    description:
      'Every client gets a dedicated account manager who understands Amazon\'s ecosystem and helps you navigate challenges proactively.',
  },
  {
    id: '6',
    icon: '🏪',
    title: 'Drop Shipping Support',
    description:
      'Sell without holding inventory. Our drop shipping service lets online retailers fulfill orders directly from our warehouse to end customers.',
  },
];

function ServicesSection() {
  const { data, loading } = useFetch(() => getServices(), []);

  if (loading) return <section className="services-bg" id="services"><div className="section-inner"><Loader /></div></section>;

  const services = Array.isArray(data) && data.length > 0 ? data : FALLBACK_SERVICES;

  return (
    <section className="services-bg" id="services">
      <div className="section-inner">
        <SectionHeading
          label="What We Offer"
          title="Everything You Need to Scale on Amazon"
          sub="We handle the supply chain complexity so you can focus on growing your business."
        />
        <div className="services-grid">
          {services.map((service) => (
            <div className="service-card" key={service.id}>
              <div className="service-icon">
                <CategoryIcon
                  icon={service.icon}
                  fallback="⚡"
                  alt={service.title}
                />
              </div>
              <h3>{service.title}</h3>
              <RichText html={service.description} tag="p" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default ServicesSection;
